import { useState } from "react";
import LazyLoad from "react-lazy-load";
import { ModalUpload, Label, Button as ExpanoButton } from "expano-components";
import { toastr } from "react-redux-toastr";

import { MainList, Main, Button } from "components";
import { sort, filters } from "./const/data";
import { client, getApiErrorMessage } from "utils/api";

import { getStatusByValue } from "utils/select_options/product_status_options";
import { ReactComponent as ProductIcon } from "icons/product.svg";
import CreateProductsFromCsvModal from "./components/CreateProductsFromCsvModal";

// const updateProductsByCsv = async (file) => {
//   try {
//     const form_data = new FormData();

//     form_data.append("file", file);

//     const { data } = await client.post("/products/update_by_csv", form_data, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     toastr.success("Sukces", "Produkty zostały zaktualizowane");

//     return data;
//   } catch (error) {
//     throw error?.response?.data?.error?.message || "Wystąpił błąd";
//   }
// };

const ProductsList = ({ history }) => {
  const [is_open_upload_modal, setOpenUploadModal] = useState(false);
  const [create_product_modal_data, setCreateProductModalData] = useState(null);
  // const [updated_products_data, setUpdatedProductsData] = useState([]);
  // const [update_products_error, setUpdateProductsError] = useState(null);
  // const [is_uploading, setUploading] = useState(false);
  // const [is_open_upload_status_modal, setOpenUploadStatusModal] =
  //   useState(false);

  // const handleUpload = async (file) => {
  //   try {
  //     setUpdateProductsError(null);
  //     setUploading(true);
  //     setOpenUploadStatusModal(true);
  //     const data = await updateProductsByCsv(file);
  //     setUpdatedProductsData(data);
  //   } catch (error) {
  //     setUpdatedProductsData([]);
  //     setUpdateProductsError(error);
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const handleUpload = async (file) => {
    try {
      const body = new FormData();
      body.append("file", file);
      const data = await client.post(`/products/preimport_csv`, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setCreateProductModalData(data);
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    }
  };

  return (
    <Main
      page={{
        name: "Produkty",
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Produkty",
          },
        ],
        buttons: (
          <>
            <ExpanoButton
              text="Dodaj produkty (.csv)"
              onClick={() => setOpenUploadModal(true)}
            />
            <Button type="add" text="Dodaj produkt" path="/products/new" />
          </>
        ),
      }}
    >
      {/* {is_open_upload_status_modal && (
        <Modal
          size="md"
          handleClose={() => setOpenUploadStatusModal(false)}
          header={{
            icon: <ProductIcon />,
            title: "Aktualizacja produktów",
          }}
          footer={
            <>
              <Button
                type="cancel"
                text="Zamknij"
                onClick={() => setOpenUploadStatusModal(false)}
              />
            </>
          }
        >
          {is_uploading ? (
            <div className="wrapper jc-c">
              <Loader />
            </div>
          ) : updated_products_data?.length > 0 ? (
            <>
              <p>Zaktualizowano produkty:</p>
              <br />
              {updated_products_data.map(({ id, sku, name }) => (
                <p key={id}>
                  {name} -{" "}
                  <a
                    className="link"
                    href={`/products/${id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {sku}
                  </a>
                </p>
              ))}
            </>
          ) : (
            <p>Brak zaktualizowanych produktów</p>
          )}
          {update_products_error && (
            <p className="text-danger m-t-10">{update_products_error}</p>
          )}
        </Modal>
      )} */}
      {create_product_modal_data && (
        <CreateProductsFromCsvModal
          {...create_product_modal_data}
          handleClose={() => setCreateProductModalData(null)}
        />
      )}
      {is_open_upload_modal && (
        <ModalUpload
          handleUpload={handleUpload}
          headerText="Wgraj plik (.csv)"
          accept=".csv"
          handleClose={() => setOpenUploadModal(false)}
        />
      )}
      <MainList
        query_key="products"
        context="ui_index"
        api_path="/products"
        sort_column="created_at"
        sort_direction="desc"
        sort={sort}
        filters={filters}
        handleNavigate={(item, e) =>
          e?.button === 1
            ? window.open(`/products/${item.id}`, "_blank")
            : history.push(`/products/${item.id}`)
        }
        renderItem={({
          sku,
          global_image_url,
          name,
          status,
          root_taxon,
          producer,
          brand,
          channels,
        }) => (
          <>
            <td>
              {global_image_url && (
                <LazyLoad height={40}>
                  <img
                    alt={name}
                    src={global_image_url}
                    style={{
                      width: 40,
                      height: 40,
                    }}
                  />
                </LazyLoad>
              )}
            </td>
            <td>{sku}</td>
            <td>{name}</td>
            <td>{getStatusByValue(status)}</td>
            <td>{root_taxon?.name}</td>
            <td>{producer?.name}</td>
            <td>{brand?.name}</td>
            <td>
              <div style={{ display: "flex", gap: "13px 0", flexFlow: "wrap" }}>
                {channels
                  ?.sort((a, b) => a.id - b.id)
                  ?.map(({ id, shop, platform }) => (
                    <span key={id} style={{ whiteSpace: "nowrap" }}>
                      <Label
                        type="double"
                        left={{
                          text: shop?.label_text,
                          color: `#${shop?.label_color}`,
                        }}
                        right={{
                          text: platform?.label_text,
                          color: `#${platform?.label_color}`,
                        }}
                      />
                    </span>
                  ))}
              </div>
            </td>
          </>
        )}
      />
    </Main>
  );
};

export default ProductsList;
